import { render, staticRenderFns } from "./ProductProposal.vue?vue&type=template&id=50087842&scoped=true&"
import script from "./ProductProposal.vue?vue&type=script&lang=js&"
export * from "./ProductProposal.vue?vue&type=script&lang=js&"
import style0 from "./ProductProposal.vue?vue&type=style&index=0&id=50087842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50087842",
  null
  
)

component.options.__file = "ProductProposal.vue"
export default component.exports